var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper" }, [
    _vm.isInitializing
      ? _c(
          "div",
          { staticClass: "auth-loading" },
          [
            _c(
              "v-overlay",
              { attrs: { value: true, color: "primary", opacity: "0.8" } },
              [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        size: 60,
                        width: 6,
                        color: "white",
                        indeterminate: ""
                      }
                    }),
                    _c("h3", { staticClass: "white--text mt-4" }, [
                      _vm._v(_vm._s(_vm.$t("auth.initializing")))
                    ]),
                    _c("p", { staticClass: "white--text mt-2" }, [
                      _vm._v(_vm._s(_vm.$t("auth.initializingMessage")))
                    ])
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      : _c("div", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }